import React, { useState } from 'react';
import './Login.css';
import config from '../config';

const Login = ({ onLogin }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [loginMethod, setLoginMethod] = useState(() => {
    return localStorage.getItem('loginMethod') || 'password';
  });

  const handleMethodChange = (method) => {
    setLoginMethod(method);
    localStorage.setItem('loginMethod', method);
    setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);

    try {
      // Chọn endpoint dựa trên phương thức đăng nhập
      const endpoint = loginMethod === 'ldap' 
        ? config.endpoints.auth.ldapLogin
        : config.endpoints.auth.passwordLogin;

      let response;
      
      if (loginMethod === 'ldap') {
        // Gửi data dạng JSON cho LDAP login
        response = await fetch(`${config.API_URL}${endpoint}`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            username,
            password
          })
        });
      } else {
        // Giữ nguyên FormData cho password login
        const formData = new FormData();
        formData.append('username', username);
        formData.append('password', password);
        
        response = await fetch(`${config.API_URL}${endpoint}`, {
          method: 'POST',
          body: formData
        });
      }

      if (!response.ok) {
        throw new Error('Login failed');
      }

      const data = await response.json();
      if (data.status === 1 && data.url) {
        const token = data.url.split('id=')[1];
        localStorage.setItem('authToken', token);
        onLogin(token);
      } else {
        throw new Error('Invalid response format');
      }
    } catch (err) {
      setError('Invalid username or password');
    } finally {
      setIsLoading(false);
    }
  };

  const handleOfficeLogin = async () => {
    setError('');
    setIsLoading(true);

    try {
      // Bước 1: Gọi API login365
      const loginResponse = await fetch(`${config.API_URL}${config.endpoints.auth.login365}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      });

      if (!loginResponse.ok) {
        throw new Error('Office 365 login failed');
      }

      const loginData = await loginResponse.json();
      
      // Bước 2: Gọi API auth/login với token nhận được
      if (loginData.status === 1 && loginData.url) {
        const token = loginData.url.split('id=')[1];
        
        const authResponse = await fetch(`${config.API_URL}${config.endpoints.auth.login}`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          }
        });

        if (!authResponse.ok) {
          throw new Error('Authentication failed');
        }

        const authData = await authResponse.json();
        if (authData.status === 1) {
          localStorage.setItem('authToken', token);
          onLogin(token);
        } else {
          throw new Error('Invalid authentication response');
        }
      } else {
        throw new Error('Invalid login response format');
      }
    } catch (err) {
      setError('Office 365 login failed. Please try again.');
      console.error('Login error:', err);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-form">
        <div className="login-header">
          <img 
            src="/zalopay_logo/Logo FA-09.png"
            alt="ZaloPay Logo"
            height="40"
          />
          <h1>Ads Report</h1>
        </div>
        
        {error && (
          <div className="error-message">
            <i className="fas fa-exclamation-circle"></i>
            {error}
          </div>
        )}

        <div className="login-methods">
          <label className={`method-radio ${loginMethod === 'password' ? 'active' : ''}`}>
            <input
              type="radio"
              name="loginMethod"
              value="password"
              checked={loginMethod === 'password'}
              onChange={(e) => handleMethodChange(e.target.value)}
            />
            <span className="radio-label">Password</span>
          </label>
          <label className={`method-radio ${loginMethod === 'ldap' ? 'active' : ''}`}>
            <input
              type="radio"
              name="loginMethod"
              value="ldap"
              checked={loginMethod === 'ldap'}
              onChange={(e) => handleMethodChange(e.target.value)}
            />
            <span className="radio-label">LDAP</span>
          </label>
        </div>

        {(loginMethod === 'password' || loginMethod === 'ldap') && (
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <input
                type="text"
                placeholder="Username"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                required
              />
            </div>
            <div className="form-group">
              <input
                type="password"
                placeholder={loginMethod === 'password' ? 'Password' : 'PIN + OTP'}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>
            <button type="submit" className="login-button" disabled={isLoading}>
              {isLoading ? 'Signing in...' : `Sign in with ${loginMethod.toUpperCase()}`}
            </button>
          </form>
        )}

        <div className="login-divider">
          <span>OR</span>
        </div>

        <button 
          className="office-login-button"
          onClick={handleOfficeLogin}
          disabled={true}
        >
          <i className="fab fa-microsoft"></i>
          <span>
            Login with VNG Office 365 (Coming soon)
          </span>
        </button>
      </div>
    </div>
  );
};

export default Login; 